/**
 * Removes common image extensions from a string
 *
 * @param str - The string to remove extensions from
 * @returns {string} The string without image extensions
 */
export function removeImageExtensions(str: string): string {
  return str.replace(/\.(jpg|jpeg|png|gif|webp|avif)$/i, '')
}
